import * as React from 'react'

import { splitCamelCase } from '@sales-center/common'
import { creditCardExpirationDate } from '@sales-center/common'
import { PaymentMethodAccountTypes } from '@user/store/payments'

import {
  Alert,
  Panel,
  TableCell,
  TableHeadCell,
  CircularProgress,
} from '../atoms'
import { useData } from './useData'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export type PaymentsProps = {
  externalSvcLocId: string
}

export function Payments(props: PaymentsProps) {
  const { title, status, payments } = useData(props)

  return (
    <Panel title={title} icon="payment">
      {status === 'pending' && <CircularProgress />}

      {status === 'fail' && (
        <Alert severity="error">Failed to load Payment Methods.</Alert>
      )}

      {status === 'success' &&
        (payments.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell>Name</TableHeadCell>
                <TableHeadCell>Account Type</TableHeadCell>
                <TableHeadCell>Account No.</TableHeadCell>
                <TableHeadCell>Expiration</TableHeadCell>
                <TableHeadCell>Primary</TableHeadCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payments.map((p) => (
                <TableRow key={p.id}>
                  <TableCell>{p.nameOnCard}</TableCell>
                  <TableCell>
                    {p.accountType === PaymentMethodAccountTypes.CreditCard
                      ? splitCamelCase(p.creditCardType)
                      : p.accountType}
                  </TableCell>
                  <TableCell>{p.accountNumber}</TableCell>
                  <TableCell>
                    {p.accountType === PaymentMethodAccountTypes.CreditCard
                      ? creditCardExpirationDate(p.expirationDate)
                      : ''}
                  </TableCell>
                  <TableCell>
                    {p.isPrimary && (
                      <CheckCircleIcon
                        color="primary"
                        fontSize="small"
                        data-test-id={`soldServicesPrimaryPaymentIcon-${p.id}`}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Alert severity="info">
            This Opportunity has no associated Payment Methods
          </Alert>
        ))}
    </Panel>
  )
}
